import { Component, computed, inject } from '@angular/core';
import { EditFormSkeleton } from '../../../../shared/components/edit-form-skeleton/edit-form-skeleton';
import { NgIcon } from '@ng-icons/core';
import { Alert } from 'excellence-ui';
import { ParseRequestsStore } from '../../stores/parse-requests.store';
import { ParseRequestsDetailsPage } from '../parse-requests-details-page/parse-requests-details-page';
import { ParseRequestsDetailsEditForm } from '../../components/parse-requests-details-edit-form/parse-requests-details-edit-form';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-parse-requests-details-general-page',
  imports: [EditFormSkeleton, NgIcon, Alert, ParseRequestsDetailsEditForm, TranslocoPipe],
  templateUrl: './parse-requests-details-general-page.html',
})
export class ParseRequestsDetailsGeneralPage {
  private parseRequestsStore = inject(ParseRequestsStore);

  private detailsPage = inject(ParseRequestsDetailsPage);

  protected parseRequestId = this.detailsPage.parseRequestId;
  protected organizationId = this.detailsPage.organizationId;

  protected parseRequestState = computed(() => {
    const parseRequestId = this.parseRequestId();
    return this.parseRequestsStore.parseRequests()?.find((p) => p.id === parseRequestId);
  });
}
